import { FaExclamationTriangle, FaClock, FaEnvelope, FaInfoCircle } from "react-icons/fa";

const ExamExpired = ({ examId, userId }) => {
  return (
    <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'var(--background-color)', zIndex: 9999 }}>
      <div className="w-4/5 max-w-2xl bg-var(--background-color) border border-var(--border-color) rounded-2xl p-12 text-center relative overflow-hidden shadow-2xl">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-2 bg-yellow-500"></div>
        <div className="absolute top-4 right-4 w-16 h-16 bg-yellow-500 rounded-full opacity-20"></div>
        <div className="absolute bottom-4 left-4 w-12 h-12 bg-yellow-500 rounded-full opacity-15"></div>

        {/* Warning Icon */}
        <div className="relative z-10 mb-8">
          <div className="w-24 h-24 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <FaExclamationTriangle className="text-white text-4xl" />
          </div>
        </div>

        {/* Content */}
        <div className="relative z-10">
          <h2 className="text-4xl font-bold text-var(--text-color) mb-4">The Exam Has Ended</h2>
          <p className="text-lg text-var(--text-color) opacity-80 mb-8 leading-relaxed">
            Unfortunately, the exam has ended.
            Your exam session has been automatically closed.
          </p>

          {/* Info Box */}
          <div className="mb-8 p-6 bg-var(--background-color) border border-var(--border-color) rounded-xl">
            <div className="flex items-center justify-center mb-4">
              <FaClock className="text-yellow-500 text-2xl mr-3" />
              <FaEnvelope className="text-yellow-500 text-2xl mr-3" />
              <FaInfoCircle className="text-yellow-500 text-2xl" />
            </div>
            <p className="text-lg text-var(--text-color) opacity-80 leading-relaxed">
              Your exam results will be sent to you via both message and email within three business days.
            </p>
          </div>

          {/* Additional Info */}
          <div className="mt-8 p-4 bg-var(--background-color) border border-var(--border-color) rounded-lg">
            <p className="text-sm text-var(--text-color) opacity-70">
              Please ensure you complete future exams within the allocated time limit.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamExpired;
